import React from 'react';
import { LinearProgress } from '@material-ui/core';
import glamorous from 'glamorous';
import gql from 'graphql-tag';
import { RvLoader } from '../Loader';
import { Query } from 'react-apollo';
import { GetAffinityFirmProvisionStatusType } from './AffinityFirmProvisionStatusType';
import DoneAll from '@material-ui/icons/DoneAll';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import { RvButton } from '../Button';

interface AffinityProvisioningInProgressProps {

}

interface AffinityProvisioningInProgressState {
}

// tslint:disable-next-line:no-any
const AffinityProvisioningWrapper = glamorous.div<{theme?: any}> (() => ({
    padding: '20px 1rem 0 1rem',
    marginTop: '50px',
    textAlign: 'center',
    [`& .${`message`}`]: {
        fontSize: '18px',
        marginTop: '10px',
        fontWeight: 600,
    },
    [`& .${`centered`}`]: {
        justifyContent: 'center'
    }    
}));

// tslint:disable-next-line: no-any
export const ProvisionMessageWrapper = glamorous.div<{ theme?: any }>((props) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column wrap',

    [`& .${`provision-icon-wrapper`}`]: {
        marginBottom: '40px',
        textAlign: 'center',
        color: 'rgb(112, 211, 137)',
        [`& .${`label`}`]: {
            fontWeight: 700,
            fontSize: '24px',
        },
    },

    [`& .${`provision-icon-container`}`]: {
        border: '5px solid',
        borderRadius: '50%',
        width: '100px',
        height: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'inherit',
        margin: '0 auto 10px auto',
    },

    [`& .${`provision-message-wrapper`}`]: {
        textAlign: 'center',
    }    
}));

// tslint:disable-next-line:no-any
const LoaderWrapper = glamorous.div<{theme?: any}> (() => ({
    display: 'flex',
    alignItems: 'center',   
    justifyContent: 'center', 
}));

// tslint:disable-next-line:no-any
const ProvisionLoaderWrapper = glamorous.div<{theme?: any}> (() => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',   
    justifyContent: 'center', 
    color: 'blue'
}));

// tslint:disable-next-line:no-any
const ProgressWrapper = glamorous.div<{theme?: any}> (() => ({
    display: 'flex',
    flexFlow: 'column wrap',
}));

// tslint:disable-next-line:max-line-length
export default class AffinityProvisioningInProgress extends React.Component<AffinityProvisioningInProgressProps, AffinityProvisioningInProgressState>  {
    private isSubscribed: boolean;
    private currentStatus: number;
    private progress: number;
    constructor(props: AffinityProvisioningInProgressProps, state: AffinityProvisioningInProgressState) {
        super(props, state);
        
        this.isSubscribed = false;
        this.currentStatus = 0;
        this.progress = 0;       
    }

    render() {
        return(            
            // tslint:disable-next-line: no-any
            <Query<any> query={TenantData}>
            {({subscribeToMore, loading, error, data }) => {
                if (loading || error || !data || !data.tenant || 
                    !data.tenant.affinityProvisioningStatus) {
                    return (
                        <LoaderWrapper>
                            <RvLoader size="large" />    
                        </LoaderWrapper>                    
                    );
                }

                if (!this.isSubscribed) {
                    this.isSubscribed = true;
                    this.subscribeProvisionAffinityFirm(subscribeToMore);
                }

                let newStatus = GetAffinityFirmProvisionStatusType(data.tenant.affinityProvisioningStatus);

                if (newStatus > this.currentStatus) {
                    this.progress = 20 * newStatus;
                    this.currentStatus = newStatus;
                }

                let message = '';
                if (this.currentStatus === 5) {
                    message = 'Step ' + this.currentStatus + ' of 5 completed.';
                } else {
                    let nextStep = this.currentStatus + 1;
                    message = 'Step ' + nextStep + ' of 5 in progress.';
                }

                if (this.currentStatus === 5 ) {
                    return(
                        <ProvisionMessageWrapper>
                            <div className="provision-icon-wrapper">
                                <div className="provision-icon-container">
                                    <DoneAll className="icon" style={{ fontSize: 50 }}/>
                                </div>
                                <div className="label">Success</div>
                            </div>
                            <div className="provision-message-wrapper">
                                <h4>Redview has been successfully provisioned and is ready for use.</h4>                                
                            </div>
                            <br />
                            <div className="provision-message-wrapper">
                                <h5>Click the button below to continue using the app or simply close the browser.</h5>
                                <RvButton
                                    label="Continue.."
                                    onClick={(e) => {
                                        e.preventDefault();
                                        // tslint:disable-next-line:max-line-length
                                        window.parent.location.href = window.parent.location.protocol + '//' + window.parent.location.host + '/matterSummary';
                                    }}
                                />
                            </div>
                        </ProvisionMessageWrapper>
                    );
                } else if (this.currentStatus === 7) { // failed
                    return(
                        <ProvisionMessageWrapper>
                            <div className="provision-icon-wrapper">
                                <div className="provision-icon-container" style={{ color: 'red' }}>
                                    <ErrorOutline className="icon" style={{ fontSize: 50 }}/>
                                </div>
                                <div className="label" style={{ color: 'red' }}>Failed</div>
                            </div>
                            <div className="provision-message-wrapper">
                                <h4>RedView was unable to complete provisioning. </h4>
                                <p>Please contact <a href="#"> support@redview.com.au</a></p>
                            </div>
                        </ProvisionMessageWrapper>
                    );
                } else {
                    return (
                        <ProgressWrapper>
                            <AffinityProvisioningWrapper>
                                <h4>RedView is now provisioning your system… please wait</h4>
                                <p className="small">This process will take some time.</p>
                                <p className="small">You may close the browser if required. 
                                    You will be contacted when RedView is available for use.
                                </p>
                                <LinearProgress 
                                    color="primary" 
                                    variant="determinate" 
                                    value={this.progress}  
                                    style={{ height: 15, marginTop: 30 }}
                                />
                                <div className="message">
                                    {message}  
                                </div>                      
                            </AffinityProvisioningWrapper>                    

                            <ProvisionLoaderWrapper>
                                <RvLoader size="huge" label="Provisioning..."/>
                            </ProvisionLoaderWrapper>
                        </ProgressWrapper>
                    );
                }
            }}
            </Query>            
        );
    }

    // tslint:disable-next-line:no-any
    private subscribeProvisionAffinityFirm = async (subscribeToMore: any) => {
        subscribeToMore({
            document: ProvisionAffinityFirmNotification,            
            // tslint:disable-next-line:no-any
            updateQuery: (prev: any, subscriptionData: any) => {
                if (!subscriptionData.subscriptionData.data) {
                    return prev;
                }
                           
                const data = subscriptionData.subscriptionData.data.provisionAffinityFirmNotification;
                const newData =  { 
                    tenant : { 
                        __typename: 'Tenant',                  
                        affinityProvisioningStatus: data.affinityProvisioningStatus
                }};
                return newData;                
            },
            variables: {                 
            }
        });
    }    
}

export const ProvisionAffinityFirmNotification = gql`subscription ProvisionAffinityFirmNotification {
    provisionAffinityFirmNotification {
        id
        affinityProvisioningStatus
        description
        message
        status
    }
}`;

const TenantData = gql`query Tenant {
    tenant {
        sourceSystem
        affinityProvisioningStatus
    }
}`;